var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticStyle:{"max-width":"1468px","margin":"0px auto"}},[_c('p',[_vm._v("版权所有：武汉市少年儿童图书馆 鄂ICP备05013209号-1 鄂公网安备 42010202000925号 地址：武汉市江岸区南京路86号 电话：（027）82773406")])])])
}]

export { render, staticRenderFns }